<template>
  <div class="about-container">
    <div class="about-container-left">
      <pageNav />
    </div>
    <div class="about-container-right">
      <div class="about-container-right-content" v-html="text">
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
import logo from '@/assets/logo/logo-blank.png'
export default {
  name: 'AboutHome',
  meta: {
    title: i18n.$t('关于')
  },
  data () {
    return {
      text: this.$i18n.$t(`
        <img src="${logo}" alt="">
        <!-- <div class="about-container-right-content-team">开发团队：北京科技大学团队</div> -->
        <div class="about-container-right-content-p">大藏经中的历代高僧传包含《高僧传》《续高僧传》《宋高僧传》《大明高僧传》《比丘尼传》《出三藏记集》《名僧传抄》《补续高僧传》等多部传记，包含人物两千余人，从文献学、历史学和社会学的角度都具有重要的历史文献价值和学术研究价值。然而，历代高僧传涉及人物众多、信息量大、脉络复杂，仅依靠原文文本对于阅读理解和学术研究都有不小的挑战。尤其是传记中的人物-时间-地点-传承之间的关系，对于研究历代高僧的社会关系、弘法轨迹、法脉传承至关重要，但如果单纯依靠原文文本，则很难进行系统化的梳理和发现。近年来结合信息科学与人文学科的数字人文技术得到迅速发展，其中的知识图谱技术致力于关系发掘与可视化呈现，可以深度发掘大规模文本数据背后的关系，并进行可视化的视觉呈现，因此非常适合用于历代高僧传记的研究工作。</div>
        <div class="about-container-right-content-p">2025年年初，北京如是人工智能技术研究院历时五年，完成了《径山藏》的全部内容数字化，并在如是佛典平台（https://www.rushi-ai.com）上线。在这一契机下，如是研究院发起了“历代高僧传知识图谱”专题项目，旨在基于《径山藏》的数字化文本，以及国内外在高僧传领域知识图谱的已有研究积累，整理与搭建历代高僧传知识图谱研究平台，为研究人员与读者提供研究与阅读的便利。本项目的主要功能包括人物社会关系图谱、人物师承关系图谱、人物足迹图谱、人物-地点关系图谱、人物-记载关系图谱、时间图谱等。所构建的知识图谱融合人物、时间、地点等多实体及相互关系，采用社会网络技术、地理信息技术等，实现在一个平台集成所有实体关系的呈现和挖掘。此外，人物检索结果包括了人物基础数据及关系图谱、原文、白话文等全方位信息，同时高僧传记的图谱检索与如是佛典平台的阅读功能实现了无缝连接。</div>
        <div class="about-container-right-content-p">本项目的《梁高僧传》《唐高僧传》《宋高僧传》《明高僧传》《比丘尼传》《出三藏记集》等六部传记的原文数据来自于如是佛典平台的《径山藏》，《名僧传抄》《补续高僧传》的原文数据来自于CBETA《卍新纂大日本续藏经》（X1523、X1524）。所使用的文本字数约为133万字。</div>
        <div class="about-container-right-content-p">在此，特别感谢法鼓文理学院所提供的共享基础数据和前期研究工作成果，具体如下：</div>
        <div class="about-container-right-content-p">本项目的人物基础数据及师承关系数据提取于法鼓文理学院人名规范资料库<a href="https://authority.dila.edu.tw/person/" target="_blank">https://authority.dila.edu.tw/person/</a></div>
        <div class="about-container-right-content-p">本项目的社会关系、人-地关系提取于法鼓文理学院的专案“一种资料集 三种呈现”的标注数据<a href="http://buddhistinformatics.dila.edu.tw/biographies/gis/" target="_blank">http://buddhistinformatics.dila.edu.tw/biographies/gis/</a></div>
        <div class="about-container-right-content-p">本项目的地点数据提取于法鼓文理学院地名规范资料库<a href="https://authority.dila.edu.tw/place/" target="_blank">https://authority.dila.edu.tw/place/</a></div>
        <div class="about-container-right-content-p">本项目的朝代数据提取于法鼓文理学院时间规范资料库<a href="https://authority.dila.edu.tw/time/" target="_blank">https://authority.dila.edu.tw/time/</a></div>
        <div class="about-container-right-content-p">本项目提供的所有数据受著作权法保护，数据使用限定于个人或团体的非盈利用途。若用于盈利性目的，必须事先取得本单位和原始数据版权者的同意。在对本项目数据进行传播、引用或再加工发行时，以不改变实质内容为原则，并需在使用时标注本项目数据来源，以利于使用者查询到相关原始信息。</div>
        <div class="about-container-right-content-p">本项目为非盈利公益项目，对于使用本项目数据产生的任何后果，本单位一概不负任何责任。</div>
        <div class="about-container-right-content-p">欢迎对数据的错漏之处提出完善建议，欢迎使用者进行学术研究合作，本项目联系方式：<span style="color: blue;">tripitakas@rushi-ai.net</span>。</div>`)
    }
  }
}
</script>
